/* eslint-disable */
// /src/pages/NotificationsPage.jsx
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import FooterCompanyInfo from "components/FooterCompanyInfo";
import BottomNav from "../components/BottomNav";
import { useAppConfig } from "../context/AppConfigContext";
import { listMyNotifications, markMyNotificationRead } from "../services/notificationsService";

/* 공통 레이아웃 (MyInfoPage 톤) */
const Wrap = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #d7e8ff 0%, #eaf3ff 100%);
  display: flex;
  flex-direction: column;
`;
const Sheet = styled.div`
  background: #f7faff;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05);
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
`;
const Body = styled.div`
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  max-width: 880px;
  width: 100%;
  margin: 0 auto;
`;

/* 상단 헤더 이미지 */
const HeaderSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 4px;
  margin-bottom: 8px;
`;
const HeaderImg = styled.img`
  display: block;
  height: auto;
`;

/* 리스트 */
const Card = styled.button`
  width: 100%;
  text-align: left;
  border: 1px solid #e5e7eb;
  background: ${(p) => (p.$unread ? "#ffffff" : "#f9fafb")};
  border-radius: 16px;
  padding: 14px 14px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #ef4444;
  display: ${(p) => (p.$show ? "inline-block" : "none")};
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
`;

const BodyText = styled.div`
  font-size: 13px;
  color: #64748b;
  line-height: 1.35;
  white-space: pre-line;
`;

const Meta = styled.div`
  font-size: 11px;
  color: #9ca3af;
`;

const Empty = styled.div`
  padding: 14px 2px;
  font-size: 13px;
  color: #9ca3af;
`;

const BottomPad = styled.div`
  height: max(24px, env(safe-area-inset-bottom));
`;

function formatTS(ts) {
    if (!ts) return "";
    try {
        const d = ts.toDate ? ts.toDate() : new Date(ts);
        if (!d || isNaN(d.getTime())) return "";
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const hh = String(d.getHours()).padStart(2, "0");
        const mm = String(d.getMinutes()).padStart(2, "0");
        return `${y}-${m}-${day} ${hh}:${mm}`;
    } catch {
        return "";
    }
}

export default function NotificationsPage() {
    const navigate = useNavigate();

    const { config, loading: configLoading } = useAppConfig();
    const detail = config?.detailScreens || {};
    const headerImg =
        detail?.noticeCenter?.headerImg ||
        detail?.myInfo?.headerImg ||
        "";

    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    const refresh = async () => {
        setLoading(true);
        try {
            const list = await listMyNotifications({ limitCount: 80 });
            setRows(list || []);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        refresh();
    }, []);

    const items = useMemo(() => {
        return (rows || []).map((r) => {
            const unread = r.read !== true;
            return {
                ...r,
                unread,
                when: formatTS(r.createdAt),
            };
        });
    }, [rows]);

    const onClickItem = async (it) => {
        if (it.unread) {
            try {
                await markMyNotificationRead(it.id);
                setRows((prev) =>
                    (prev || []).map((x) => (x.id === it.id ? { ...x, read: true } : x))
                );
            } catch (e) {
                console.warn("[NotificationsPage] mark read failed", e);
            }
        }

        // 주문으로 이동하고 싶으면 다음 단계에서 연결
        // if (it.orderId) navigate(`/orders?highlight=${it.orderId}`);
    };

    return (
        <Wrap>
            <Sheet>
                <Body>
                    <div
                        style={{
                            padding: "8px 2px 6px",
                            fontSize: 18,
                            fontWeight: 800,
                            color: "#111827",
                        }}
                    >
                        알림
                    </div>
                    <div
                        style={{
                            padding: "0 2px 8px",
                            fontSize: 13,
                            color: "#6b7280",
                        }}
                    >
                        푸시알림 내역을 확인할 수 있습니다.
                    </div>

                    {loading ? (
                        <Empty>불러오는 중…</Empty>
                    ) : items.length === 0 ? (
                        <Empty>알림이 없습니다.</Empty>
                    ) : (
                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                            {items.map((it) => (
                                <Card
                                    key={it.id}
                                    type="button"
                                    onClick={() => onClickItem(it)}
                                    $unread={it.unread}
                                >
                                    <Row>
                                        <Dot $show={it.unread} />
                                        <Title>{it.title || "알림"}</Title>
                                    </Row>
                                    <BodyText>{it.body || ""}</BodyText>
                                    <Meta>{it.when}</Meta>
                                </Card>
                            ))}
                        </div>
                    )}

                    <BottomPad />
                </Body>
            </Sheet>

            <BottomNav
                active="notifications"
                navigate={(p) => navigate(p)}
                onChange={() => { }}
            />

            <FooterCompanyInfo />
        </Wrap>
    );
}
